
import './about-gallery.scss';
import type { AboutGalleryItem } from '../../../interfaces/about';

export function AboutGallery({ images, caption }: AboutGalleryItem) {

  if (!images?.length) {
    return null;
  }

  return (
    <section className="about-gallery">
      <div className="about-gallery-container">
        <div className="about-gallery-grid">
          {images?.map((item,index) => (
            <figure className="about-gallery-item" key={index}>
              <img className="about-gallery-image" src={`/api/assets/${item.directus_files_id}?key=original`} alt={caption || 'Image About'} loading="lazy" />
            </figure>
          ))}
        </div>

        {caption && <p className="about-gallery-caption">{caption}</p>}
      </div>
    </section>
  );
}
